"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _takeoutFood = _interopRequireDefault(require("@atlaskit/icon/core/takeout-food"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EmojiFoodIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M9.425 4.798v.005L9.271 7H4.995a.88.88 0 0 0-.885.999L5.319 19c.06.552.556.999 1.108.999H17.99A2.006 2.006 0 0 0 20 18v-3.99A4 4 0 0 0 16.004 10H13.56l.294-2.001c.08-.552-.3-.999-.85-.999h-1.728l.075-1.07 3.002.21a1 1 0 0 0 1.058-.928.993.993 0 0 0-.919-1.067l-4.008-.28a1 1 0 0 0-1.059.933M18 15v-1.002A2 2 0 0 0 16.002 12h-4.004A1.993 1.993 0 0 0 10 13.998V15zm0 2v1h-8v-1zm-6.111-6.999L12 9H6l1 9h1v-3.99A4.01 4.01 0 0 1 11.889 10"/></svg>`
}, props, {
  newIcon: _takeoutFood.default
}));
EmojiFoodIcon.displayName = 'EmojiFoodIcon';
var _default = exports.default = EmojiFoodIcon;